import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

// Direct imports (not the barrel): keeps `@mui/x-date-pickers` out of the
// routed bundle — this page has no date filter.
import { FilterBar } from '../../../components/filters/FilterBar';
import { SearchInput } from '../../../components/filters/SearchInput';
import { STATUS_OPTIONS, type CompanyFilters } from '../_lib/companyFilters';

/**
 * Filter toolbar for `/companies` (AUT-403): search + Статус. Values live in
 * the URL via the parent's `setFilters`.
 */
const MIN_SEARCH_LENGTH = 2;

export interface CompaniesFilterBarProps {
  filters: CompanyFilters;
  setFilters: (patch: Partial<Record<keyof CompanyFilters, string | null>>) => void;
  canClear: boolean;
  onClear: () => void;
}

export const CompaniesFilterBar = ({
  filters,
  setFilters,
  canClear,
  onClear,
}: CompaniesFilterBarProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <FilterBar canClear={canClear} onClear={onClear}>
      <SearchInput
        initialValue={filters.q ?? ''}
        placeholder={t('companies.search.placeholder')}
        minLength={MIN_SEARCH_LENGTH}
        onSearch={(q) => setFilters({ q: q || null })}
      />
      <TextField
        select
        size="small"
        label={t('companies.filters.statusLabel')}
        value={filters.status}
        onChange={(e) => setFilters({ status: e.target.value === 'all' ? null : e.target.value })}
        sx={{ minWidth: 170 }}
      >
        {STATUS_OPTIONS.map((s) => (
          <MenuItem key={s} value={s}>
            {t(`companies.filters.status.${s}`)}
          </MenuItem>
        ))}
      </TextField>
    </FilterBar>
  );
};
